import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 mt-auto">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <nav className="flex flex-col items-center space-y-4">
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600">
            <Link to="/privacy-policy" className="hover:text-primary">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="hover:text-primary">
              Terms and Conditions
            </Link>
            <Link to="/disclaimer" className="hover:text-primary">
              Disclaimer
            </Link>
            <Link to="/cookie-policy" className="hover:text-primary">
              Cookie Policy
            </Link>
            <Link to="/california-privacy-rights" className="hover:text-primary">
              California Privacy Rights
            </Link>
          </div>
          <div className="text-sm text-gray-600">
            Copyright {currentYear} — Content Creator AI. All rights reserved.
          </div>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
